import { LOCALES } from "@marketplace/i18n";

export const cardsI18n = {
    [LOCALES.ENG]: {
        'developer_main_page_card_title_first': 'Learn our FHIR API',
        'developer_main_page_card_text_first': 'Get access to our APIs and documentation to start building and integrating applications.',

        'developer_main_page_card_title_second': 'Build and test your app',
        'developer_main_page_card_text_second': 'Use our isolated sandbox environments to test your apps with the real data before publishing them on Marketplace.',

        'developer_main_page_card_title_third': 'Deploy your app',
        'developer_main_page_card_text_third': 'Launch, promote, and sell your apps on our Marketplace, our app store for customizations and integrations.',
    }
}